<template>
    <div :class="['slider-container', {'is-large': isLarge}]" :ref="`slider_${ id }`">

        <article :class="['slide', {'active': isActiveSlide(index)}]"
                 v-for="(slide, index) in slides"
                 :key="slide.id"
                 :style="`left: ${ 590 * (index - currentActiveTab) }px`"
                 @click="setSlide(index)"
        >

            <div class="slide-progressbar">
                <div class="background"></div>
                <div class="progress"
                     :style="`width: ${ isActiveSlide(index) ? (currentProgress / slideDuration) * 100 : 100 }%`"
                >
                </div>
            </div>

            <h3 class="is-lessened">{{ slide.title }}</h3>

            <ul class="marked-list" v-if="typeof slide.text === 'object'">

                <li v-for="text in slide.text" :key="text.id">
                    <p class="text is-small">{{ text }}</p>
                </li>

            </ul>

            <p class="text" v-else v-html="slide.text"></p>

        </article>

        <div class="toggle-slide_bar">

            <div class="previous"
                 @click="this.previousSlide"
                 v-if="currentActiveTab > 0"
            >
                <img src="@/assets/images/icons/arrow_right.svg">
            </div>

            <div class="next"
                 @click="this.nextSlide"
                 v-if="currentActiveTab < slides.length - 1"
            >
                <img src="@/assets/images/icons/arrow_right.svg">
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "Slider",
        props: {
            slideDuration: {
                type: Number,
                default: 10000
            },
            tickDuration: {
                type: Number,
                default: 1000 / 60
            },
            slides: {
                type: Array,
                default: () => {
                    return []
                }
            },
            isLarge: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                currentProgress: 0,
                currentActiveTab: 0,

                interval: null,
                id: 1
            }
        },
        methods: {
            isActiveSlide(index) {
                return index === this.currentActiveTab
            },
            nextSlide() {
                if (this.currentActiveTab < this.slides.length - 1) {
                    this.setSlide(this.currentActiveTab + 1)
                } else {
                    this.setSlide(0)
                }
            },
            previousSlide() {
                if (this.currentActiveTab > 0) {
                    this.setSlide(this.currentActiveTab - 1)
                }
            },
            setSlide(index) {
                clearInterval(this.interval)
                this.currentProgress = 0

                this.currentActiveTab = index
                this.setLoop()
            },
            setLoop() {
                this.interval = setInterval(() => {
                    this.currentProgress += this.tickDuration

                    if (this.currentProgress >= this.slideDuration) {

                        this.nextSlide()

                    }

                }, this.tickDuration)
            }
        },
        mounted() {
            this.$parallax.addScrollCallback(() => {

                if (window.pageYOffset + window.innerHeight > this.$refs[`slider_${ this.id }`].offsetTop) {

                    if (!this.interval) {
                        this.setLoop()
                    }

                }

            })
        },
        created() {

            this.id = Math.floor(Math.random() * 10000000)

        }
    }
</script>